// @flow
import React from "react";

import AccordionGroup from "../../components/AccordionGroup";
import { connect } from "react-redux";
import SocialButtonList from '../../components/SocialButtonList';

const PRODUCT_DETAILS_TITLE = "Product Details";

type Props = {
  accordions: Array<any>,
  productName: String,
  productUrl: String,
  productImage: String,
  leftAlign: Boolean
};

const ProductInfo = ({
  accordions,
  productName,
  productUrl,
  productImage,
  leftAlign
}: Props) => (
  <div className={`${leftAlign ? "" : "pdp-accordion__contain"}`}>
    {accordions.length ? (
      <div>
        <AccordionGroup accordions={accordions} />
      </div>
    ) : null}
    <SocialButtonList productName={productName} productUrl={productUrl} productImage={productImage} />
  </div>
);

const mapStateToProps = (state: Object) => ({
  title: state.rawProduct.accordion_title_shipping_time,
  details: state.product.detailsHtml,
  shipping: state.product.shippingInfoHtml,
  extraLabel: state.product.productDetailsExtraLabel,
  extraContent: state.product.productDetailsExtraContent,
  productName: state.product.name,
  productUrl: state.product.url,
  productImage: state.media[0].full,
  leftAlign: state.media.length < 2
});

const wrappedInArrayIfExists = key => title => obj =>
  obj[key] ? [{ title, content: obj[key] }] : [];

const mergeProps = mappedProps => ({
  ...mappedProps,
  accordions: [
    ...wrappedInArrayIfExists("shipping")(mappedProps.title)(mappedProps),
    ...wrappedInArrayIfExists("details")(PRODUCT_DETAILS_TITLE)(mappedProps),
    ...wrappedInArrayIfExists("extraContent")(mappedProps.extraLabel)(
      mappedProps
    )
  ]
});

export default connect(
  mapStateToProps,
  null,
  mergeProps
)(ProductInfo);



// WEBPACK FOOTER //
// ./src/containers/ProductInfo/index.js